import { resolveHrefFromLinkProps } from "@pathwright/ux/src/components/link/Link"
import { OrderStripeCheckoutRedirects } from "@pathwright/graphql-client/src/generated"

export function getStripeCheckoutRedirects(
  url: string
): OrderStripeCheckoutRedirects {
  const alreadyOnThankYou = /\/thank-you\//.test(url)
  const currentUrl = resolveHrefFromLinkProps({ relativeTo: "/" }, url) ?? ""
  const successPath = alreadyOnThankYou
    ? currentUrl
    : resolveHrefFromLinkProps({ relativeTo: "/thank-you/" }, url) ?? ""

  // Remove current order_id from the success URL, if any.
  const successUrl = new URL(successPath)
  successUrl.searchParams.delete("order_id")
  const success_url = successUrl.href
  const cancel_url = currentUrl

  return {
    success_url,
    cancel_url
  }
}
